import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../../../employee/service/web.service';

@Injectable()
export class ContactCandidateService extends WebService {

    public getInfo(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (id !== null && id !== undefined)
            params.append('id', String(id));
        
        const options = new RequestOptions({search: params, headers:this.headers});

        return this.http.get( `${this.apiUrl}/contacts-candidate?${params}`, options);
    }

    public add(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/contacts-candidate`, JSON.stringify(body) , { headers: this.headers } );
    }

    public delete(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/contacts-candidate/${id}`, { headers: this.headers } );
    }

    public update(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/contacts-candidate/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/candidate/services/contact-candidate/contact-candidate.service.ts